<template>
  <div>
     <!-- Simple page that loads a calculator widget, besidest the wiget this page is very simple -->
    <div class="show-bg-calc"></div>
    <div style="text-align: center" class="calc-header">
      <div class="white-fore-calc"><img class="white-fore-calc1" src="https://i.imgur.com/Xq6hO8N.png" style="border-radius: 30px;">
        <div class="calc-header-text">
          <div class="h1 calc-h1">
            <hr2 style="font-size: 1.4em"><span class="teal">Mortgage Calculators</span></hr2>
          </div>
          <div class="p1 calc-p1">
            <p style="font-size: 1.2em; line-height: 150%;">Get a clear picture of what you can afford</p>
          </div>
          <div class="calc-p2">
            <p>From estimating monthly payments to comparing refinance options, our easy-to-use calculators help take the guesswork out of your home loan decisions. It’s your first step toward feeling confident and ready.</p>
          </div>
        </div>
        <div v-if="isLoading" class="loader">
          <loader :size="'large'" />
        </div>
        <div v-else class="calculator">
          <CalculatorWidget @loaded="onWidgetLoaded"></CalculatorWidget>
        </div>
      </div>
    </div>
    <div class="white-spacing">
      <div class="blue-chunk"></div>
      <FooterComp></FooterComp>
    </div>
  </div>
</template>


<script>
import '@progress/kendo-theme-default/dist/all.css';
import apiService from '../api/api.service';
import CalculatorWidget from '../components/CalculatorWidget.vue';
import FooterComp from '@/components/Footer_Comp.vue';
import { Loader } from "@progress/kendo-vue-indicators";


export default {
  name: "Calculator-Page",
  components: {
    loader: Loader,
    CalculatorWidget,
    FooterComp
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if(searchParams.has('org')){
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: true,

    };
  },

  mounted() {
    this.GetBranchPage();
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    onWidgetLoaded() {
      console.log("Iframe loaded");
      this.isLoading = false;
    },
    sendTo(url) {
      window.location.href = url
    }
  }
};
</script>

<style>
.show-bg-calc {
  background-image: url('https://nypost.com/wp-content/uploads/sites/2/2020/07/dog-feature.jpg?resize=1536,1024&quality=75&strip=all');
  background-position: 50%;
  background-size: cover;
  width: 100%;
  margin-top: 4%;
  height: 580px;
}

.white-fore-calc {
  max-width: 1200px;
  height: 600px;
  top: -150px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.loader{
  z-index: 1;
  position: relative;
  top: 40%;
}

.calc-header-text {
  left: 50%;
  transform: translateX(-50%);
  position: fixed;
  top: 15%;
  width: 1000px;
}

.calculator {
  z-index: 3;
  background-color: white;
  margin-top: -150px;
  max-height: 200%;
}

.white-spacing {
  height: 350px;
  position: relative;
  top: 700px;
}

.calc-p2{
  justify-self: center;
  width: 70%;
}

@media (max-width: 430px){
  .show-bg-calc {
    height: 410px;
  }
  .white-fore-calc{
    left: 50%;
  }
  .white-fore-calc1{
    width: 100%;
  }
  .calculator{
    margin-top: 35%;
  }
  .calc-header-text{
    width: 100%;
  }
  .p1.calc-p1{
   width: 100%;
  }
}
</style>
